package com.zaurh.portfolio.main.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.TextSelectionColors
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.Key.Companion.P
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.zaurh.portfolio.domain.repository.ContactRepository
import com.zaurh.portfolio.main.MainViewModel
import com.zaurh.portfolio.main.SocialMediaItem
import com.zaurh.portfolio.utils.getPoppinsFont
import kotlinx.browser.window
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import portfolio.shared.generated.resources.Res
import portfolio.shared.generated.resources.app_store_logo
import portfolio.shared.generated.resources.github_logo
import portfolio.shared.generated.resources.github_logo_org
import portfolio.shared.generated.resources.google_play_logo
import portfolio.shared.generated.resources.google_play_logo_org
import portfolio.shared.generated.resources.ic_location
import portfolio.shared.generated.resources.ic_mail
import portfolio.shared.generated.resources.ic_phone
import portfolio.shared.generated.resources.linkedin_logo
import portfolio.shared.generated.resources.linkedin_logo_org
import kotlin.math.log
import kotlin.math.max

@Composable
fun ContactInfo(
    viewModel: MainViewModel
) {
    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        val isCompact = maxWidth < 1000.dp
        Column(
            modifier = Modifier.fillMaxSize().padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "Get in touch",
                color = MaterialTheme.colorScheme.primary,
                fontFamily = getPoppinsFont(),
                fontSize = 26.sp
            )
            Spacer(modifier = Modifier.height(36.dp))
            if (isCompact) {
                ContactInformation()
            } else {
                Row(
                    modifier = Modifier.fillMaxSize(),
                    horizontalArrangement = Arrangement.SpaceAround
                ) {
                    ContactInformation(modifier = Modifier.weight(1f))
                    VerticalDivider(modifier = Modifier.height(360.dp).padding(horizontal = 24.dp),thickness = 1.dp, color = MaterialTheme.colorScheme.outline.copy(alpha = 0.2f))
                    SendMessageSide(modifier = Modifier.weight(1f), viewModel = viewModel)
                }
            }
        }
    }

}

@Composable
private fun UserInfoItem(
    icon: DrawableResource,
    title: String,
    desc: String,
    clickable: Boolean = false,
    onClick: () -> Unit = {}
) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Icon(
            painter = painterResource(icon),
            contentDescription = null,
            modifier = Modifier.size(28.dp),
            tint = MaterialTheme.colorScheme.tertiary
        )
        Spacer(Modifier.width(12.dp))
        Column {
            Text(
                text = title,
                color = MaterialTheme.colorScheme.primary,
                fontFamily = getPoppinsFont(),
                fontWeight = FontWeight.Bold
            )
            Text(
                text = desc,
                color = MaterialTheme.colorScheme.primary,
                fontFamily = getPoppinsFont(),
                modifier = Modifier.pointerHoverIcon(if (clickable) PointerIcon.Hand else PointerIcon.Default).clickable(clickable) {
                    onClick()
                }
            )
        }
    }
}

@Composable
fun ContactInformation(
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier) {
        Text(
            text = "Feel free to reach out to me for any questions or opportunities. " +
                    "I'm always open to discussing new projects, creative ideas or opportunities " +
                    "to be part of your vision",
            color = MaterialTheme.colorScheme.primary,
            fontFamily = getPoppinsFont()
        )
        Spacer(modifier = Modifier.height(12.dp))
        UserInfoItem(
            icon = Res.drawable.ic_location,
            title = "Location",
            desc = "Cracow, Poland"
        )
        Spacer(modifier = Modifier.height(12.dp))
        UserInfoItem(
            icon = Res.drawable.ic_mail,
            title = "Email",
            desc = "zaurcod@gmail.com",
            clickable = true,
            onClick = {
                window.open("mailto:zaurcod@gmail.com", "_blank")
            }
        )
        Spacer(modifier = Modifier.height(12.dp))
        UserInfoItem(
            icon = Res.drawable.ic_phone,
            title = "Phone",
            desc = "+48 51 434 88 13"
        )
        Spacer(modifier = Modifier.height(12.dp))
        Text(
            "Find me",
            color = MaterialTheme.colorScheme.primary,
            fontFamily = getPoppinsFont(),
            fontWeight = FontWeight.Bold
        )
        Spacer(modifier = Modifier.height(12.dp))
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            SocialMediaItem(
                logo = Res.drawable.linkedin_logo,
                hoveredLogo = Res.drawable.linkedin_logo_org,
                size = 36.dp
            ) {
                window.open("https://linkedin.com/in/zaurh")
            }
            SocialMediaItem(
                logo = Res.drawable.google_play_logo,
                hoveredLogo = Res.drawable.google_play_logo_org,
                size = 36.dp
            ) {
                window.open("https://play.google.com/store/apps/dev?id=8494981660664456351")
            }
            SocialMediaItem(
                logo = Res.drawable.github_logo,
                hoveredLogo = Res.drawable.github_logo,
                size = 36.dp
            ) {
                window.open("https://github.com/zaurh")
            }
            SocialMediaItem(
                logo = Res.drawable.app_store_logo,
                hoveredLogo = Res.drawable.app_store_logo,
                size = 36.dp
            ) {
                window.open("https://apps.apple.com/us/developer/zaur-hasanov/id6806218069")
            }
        }
    }
}

@Composable
fun FindMeLogo(
    logo: DrawableResource,
    onClick: () -> Unit
){
    Image(
        painter = painterResource(logo),
        contentDescription = null,
        modifier = Modifier.size(24.dp).clickable {
            onClick()
        }
    )
}

@Composable
fun SendMessageSide(
    modifier: Modifier = Modifier,
    viewModel: MainViewModel
) {
    var nameField by remember { mutableStateOf("") }
    var emailField by remember { mutableStateOf("") }
    var subjectField by remember { mutableStateOf("") }
    var messageField by remember { mutableStateOf("") }

    val nameRequester = remember { FocusRequester() }
    val emailRequester = remember { FocusRequester() }
    val subjectRequester = remember { FocusRequester() }
    val messageRequester = remember { FocusRequester() }

    val buttonText by viewModel.buttonText.collectAsState()
    val buttonDisabled by viewModel.buttonDisabled.collectAsState()

    Column(modifier = modifier.fillMaxWidth()) {
        Row() {
            ContactTextField(
                modifier = Modifier.weight(1f),
                title = "Your name",
                value = nameField,
                onValueChange = { nameField = it },
                focusRequester = nameRequester,
                nextFocusRequester = emailRequester
            )
            Spacer(modifier = Modifier.width(12.dp))
            ContactTextField(
                modifier = Modifier.weight(1f),
                title = "Your email",
                value = emailField,
                onValueChange = { emailField = it },
                focusRequester = emailRequester,
                nextFocusRequester = subjectRequester
            )
        }
        Spacer(modifier = Modifier.height(8.dp))
        ContactTextField(
            modifier = Modifier.fillMaxWidth(),
            title = "Subject",
            value = subjectField,
            onValueChange = { subjectField = it },
            focusRequester = subjectRequester,
            nextFocusRequester = messageRequester
        )
        Spacer(modifier = Modifier.height(8.dp))
        ContactTextField(
            modifier = Modifier.fillMaxWidth(),
            title = "Message",
            value = messageField,
            onValueChange = { messageField = it },
            focusRequester = messageRequester,
            maxLines = 5
        )

        Spacer(modifier = Modifier.height(12.dp))

        val activeButton = !buttonDisabled && nameField.isNotEmpty() && emailField.isNotEmpty() && subjectField.isNotEmpty() && messageField.isNotEmpty()
        Button(
            enabled = activeButton,
            modifier = Modifier.fillMaxWidth().then(
                if (activeButton) {
                    Modifier.pointerHoverIcon(PointerIcon.Hand)
                } else {
                    Modifier
                }
            ),
            colors = ButtonDefaults.buttonColors(
                containerColor = MaterialTheme.colorScheme.tertiary
            ),
            onClick = {
                viewModel.sendMessage(
                    name = nameField,
                    email = emailField,
                    subject = subjectField,
                    message = messageField
                )
            }) {
            Text(
                text = buttonText,
                fontFamily = getPoppinsFont(),
                color = if (!activeButton) MaterialTheme.colorScheme.primary.copy(0.7f) else MaterialTheme.colorScheme.background,
                fontWeight = FontWeight.Bold,
            )
        }

    }
}

@Composable
fun ContactTextField(
    modifier: Modifier = Modifier,
    title: String,
    value: String,
    onValueChange: (String) -> Unit,
    focusRequester: FocusRequester = remember { FocusRequester() },
    nextFocusRequester: FocusRequester? = null,
    maxLines: Int = 1
) {
    Column(modifier = modifier) {
        Text(
            text = title,
            color = MaterialTheme.colorScheme.primary,
            fontFamily = getPoppinsFont()
        )

        Spacer(modifier = Modifier.height(8.dp))

        TextField(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(10.dp))
                .focusRequester(focusRequester)
                .onPreviewKeyEvent {
                    if (it.type == KeyEventType.KeyDown && it.key == Key.Tab) {
                        nextFocusRequester?.requestFocus()
                        true
                    } else {
                        false
                    }
                },
            value = value,
            onValueChange = onValueChange,
            maxLines = maxLines,
            textStyle = TextStyle(
                fontFamily = getPoppinsFont()
            ),
            colors = TextFieldDefaults.colors(
                focusedContainerColor = MaterialTheme.colorScheme.tertiaryContainer,
                unfocusedContainerColor = MaterialTheme.colorScheme.tertiaryContainer,
                focusedIndicatorColor = Color.Transparent,
                unfocusedIndicatorColor = Color.Transparent,
                focusedTextColor = MaterialTheme.colorScheme.background,
                unfocusedTextColor = MaterialTheme.colorScheme.background,
                cursorColor = MaterialTheme.colorScheme.background,
                selectionColors = TextSelectionColors(
                    handleColor = Color.DarkGray,
                    backgroundColor = Color.DarkGray
                )
            ),

        )
    }
}